export function queryParams (): any {
  const search = window.location.search.replace('?', '')

  // Return empty object if no query string
  if (!search) {
    return {}
  }

  const params = Object.fromEntries(
    search
      .split('&')
      .filter(x => x) // Filter out empty strings
      .map((x) => {
        const pair = x.split('=');
        return [pair[0], decodeURIComponent(pair[1] || '')];
      })
      .filter(([key]) => key) // Filter out entries with empty keys
  )

  return params
}